<template>
  <div>
    <v-container class="lighten-5">
      <v-row no-gutters class="pagination-table-header">
        <v-col col="12">
          <v-overlay
            :absolute="true"
            :value="isComponentLoading"
          >
            <v-progress-circular indeterminate size="24"></v-progress-circular>
          </v-overlay>
          <div>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  dense
                  :headers="headers"
                  :items="prepareData"
                  item-key="name"
                  class="elevation-3"
                >
                  <template v-slot:top>
                    <v-toolbar
                      flat
                    >
                      <v-toolbar-title>{{ $t('cashier.list') }}</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                      <v-dialog
                        v-model="dialog"
                        max-width="600px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            dark
                            class="mb-2"
                            v-bind="attrs"
                            v-on="on"
                          >
                            {{ $t('actions.new') }}
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                          </v-card-title>

                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col
                                  cols="12"
                                  sm="12"
                                  md="12"
                                >
                                  <v-menu
                                    v-model="datetime"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        :value="formDateFormatted"
                                        @input="changeDate('datetime', $event)"
                                        :label="lang($store, 'sap/listings.global.filter.hints.date')"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        clearable
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="editedItem.datetime" no-title
                                                   :first-day-of-week="1"
                                                   :locale="getCurrentLocale()"
                                                   @input="datetime = false"></v-date-picker>
                                  </v-menu>

                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="4"
                                >
                                  <v-select
                                    v-model="editedItem.expense_category_id"
                                    :label="lang($store, 'sap/listings.global.filter.hints.category')"
                                    :items="expenseCategoryItems"
                                    persistent-hint
                                    single-line
                                    :loading="false"
                                  ></v-select>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="4"
                                >
                                  <v-select
                                    v-model="editedItem.manager_id"
                                    :label="lang($store, 'sap/listings.global.filter.hints.manager')"
                                    :items="managersItems"
                                    persistent-hint
                                    single-line
                                    :loading="false"
                                  ></v-select>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="editedItem.recipient"
                                    :label="lang($store, 'sap/listings.global.filter.hints.cashier_recipient')"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="4"
                                >
                                  <v-text-field
                                    v-model="editedItem.sum"
                                    :label="lang($store, 'sap/listings.global.filter.hints.sum')"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="6"
                                  md="4"
                                >
                                  <v-select
                                    v-model="editedItem.type"
                                    :label="lang($store, 'sap/listings.global.filter.hints.type')"
                                    :items="cashierPaymentTypes"
                                    persistent-hint
                                    single-line
                                    :loading="false"
                                  ></v-select>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="12"
                                  md="12"
                                >
                                  <v-text-field
                                    v-model="editedItem.note"
                                    :label="lang($store, 'sap/listings.global.filter.hints.info')"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="blue darken-1"
                              text
                              @click="close"
                            >
                              {{ $t('actions.cancel') }}
                            </v-btn>
                            <v-btn
                              color="blue darken-1"
                              text
                              @click="save"
                            >
                              {{ $t('actions.save') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="dialogDelete" max-width="600px">
                        <v-card>
                          <v-card-title class="headline">{{ $t('cashier.modal.delete') }}?</v-card-title>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeDelete">{{ $t('actions.cancel') }}</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">{{ $t('actions.ok') }}</v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="editItem(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      small
                      @click="deleteItem(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                  <template v-slot:no-data>
                    <v-card
                      v-if="L.isEmpty(paginatedObject) || L.isEmpty(paginatedObject.data)"
                      class="pa-3">
                      <p class="text-center mt-2">
                        <v-icon>mdi-account-search-outline</v-icon>
                        <b>&nbsp;&nbsp;{{ lang($store, 'sap/listings.expenses.not_found') }}&nbsp;&nbsp;</b>
                        <v-icon>mdi-account-badge-outline</v-icon>
                      </p>
                    </v-card>
                  </template>
                </v-data-table>
              </v-col>
              <v-col cols="12" v-if="isTopManager">
                <v-data-table
                  dense
                  :headers="resultsHeaders"
                  :items="getResultsData"
                  item-key="name"
                  class="elevation-3"
                  :items-per-page="5"
                >

                  <template v-slot:top>
                    <v-toolbar
                      flat
                    >
                      <v-toolbar-title>{{ $t('cashier.results') }}</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </template>
                  <template v-slot:no-data>
                    <v-card
                      v-if="L.isEmpty(resultsObject) || L.isEmpty(resultsObject.data)"
                      class="pa-3">
                      <p class="text-center mt-2">
                        <v-icon>mdi-account-search-outline</v-icon>
                        <b>&nbsp;&nbsp;{{ lang($store, 'sap/listings.expenses.not_found') }}&nbsp;&nbsp;</b>
                        <v-icon>mdi-account-badge-outline</v-icon>
                      </p>
                    </v-card>
                  </template>
                  <template v-slot:body.append>
                    <tr>
                      <td>
                        <span
                          class="font-weight-bold"
                        >
                          {{ $t('cashier.total') }}
                        </span>

                        <v-divider
                          class="mx-4"
                          inset
                          vertical
                        ></v-divider>
                        <span
                          class="font-weight-bold"
                        >
                           {{ getResult }}
                        </span>

                      </td>
                      <td>
                      </td>
                      <td colspan="4"></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
              <v-col cols="12" v-if="isTopManager">
                <v-data-table
                  dense
                  :headers="totalsHeaders"
                  :items="prepareTotals"
                  item-key="name"
                  class="elevation-3"
                  hide-default-footer
                >
                  <template v-slot:top>
                    <v-toolbar
                      flat
                    >
                      <v-toolbar-title>{{ $t('cashier.total') }}</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </template>

                </v-data-table>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { MANAGER_TOP } from '@/constants/roles';
/* mixins */
import accountMixin from '@/mixins/accountMixin';
import isComponentLoading from '@/mixins/isComponentLoading';
import managersItems from '@/mixins/filters/managersFilter';
import expenseCategoryItems from '@/mixins/filters/expensesCategoryFilter';
import expenseDialog from '@/mixins/cashier/expenseDialog';
/* components */
import ExpensesProxy from '@/proxies/Cashier/ExpensesProxy';
import cashierPaymentTypes from '@/constants/cashier_payment_types';
import i18n from '@/i18n';

export default {
  name: 'TablePaginatedExpenses',
  components: {
    // ExpensesProxy,
  },
  mixins: [
    accountMixin,
    isComponentLoading,
    managersItems,
    expenseCategoryItems,
    expenseDialog,
  ],
  props: {
    paginatedObject: {
      type: Object,
      default: () => {
      },
    },
    resultsObject: {
      type: Object,
      default: () => {
      },
    },
    result: {
      type: Number,
      default: 0.00,
    },
    allTotals: {
      type: Object,
      default: () => {
      },
    },
    noActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      MANAGER_TOP,
      moment,
      dialog: false,
      currentItem: {},
      dialogDelete: false,
      L: _,
      expensesData: [],
      resultsData: [],
      allResult: 0.00,
      headers: [
        {
          text: i18n.t('table.headers.date'),
          value: 'datetime',
        },
        {
          text: i18n.t('table.headers.category'),
          value: 'expense_category',
        },
        {
          text: i18n.t('table.headers.manager'),
          value: 'manager',
        },
        {
          text: i18n.t('table.headers.recipient'),
          value: 'recipient',
        },
        {
          text: i18n.t('table.headers.sum'),
          value: 'sum',
        },
        {
          text: i18n.t('table.headers.payment_type'),
          value: 'type_name',
        },
        {
          text: i18n.t('table.headers.info'),
          value: 'note',
        },
        {
          text: i18n.t('table.headers.actions'),
          value: 'actions',
          sortable: false,
        },
      ],
      resultsHeaders: [
        {
          text: i18n.t('table.headers.category'),
          value: 'expense_category_name',
        },
        {
          text: i18n.t('table.headers.sum'),
          value: 'sum',
        },
      ],
      totalsHeaders: [
        {
          text: i18n.t('table.headers.name'),
          value: 'name',
        },
        {
          text: i18n.t('table.headers.sum'),
          value: 'sum',
        },
      ],
      editedIndex: -1,
      editedItem: {
        datetime: '',
        recipient: '',
        expense_category: '',
        expense_category_id: 0,
        manager: '',
        manager_id: 0,
        sum: 0.00,
        type: '',
        type_name: '',
        note: '',
      },
      datetime: false,
      allTotalsForPeriod: [],
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
    cashierPaymentTypes() {
      const paymentTypes = [];
      Object.keys(cashierPaymentTypes.CASHIER)
        .forEach(key => {
          paymentTypes.push({
            text: this.lang(this.$store, `sap/listings.global.filter.payment_types.${cashierPaymentTypes.CASHIER[key]}`),
            value: cashierPaymentTypes.CASHIER[key],
          });
        });
      return paymentTypes;
    },
    prepareData() {
      if (this.paginatedObject && this.paginatedObject.data) {
        this.expensesData = this.paginatedObject.data.map(function (item) {
          return {
            datetime: item.datetime,
            expense_category: item.expense_category,
            manager: item.manager,
            recipient: item.recipient,
            note: item.note,
            sum: item.sum,
            type: item.type,
            type_name: item.type_name ? this.lang(this.$store, `sap/listings.global.filter.payment_types.${cashierPaymentTypes.CASHIER[item.type]}`) : 'не задан',
            uuid: item.uuid,
            expense_category_id: item.expense_category_id,
            manager_id: item.manager_id,
          };
        }, this);
      }
      return this.expensesData;
    },
    getResult() {
      if (this.result) {
        this.allResult = this.result;
      }
      return this.allResult;
    },
    getResultsData() {
      if (this.resultsObject && this.resultsObject.data) {
        this.resultsData = this.resultsObject.data.map(item => ({
          sum: item.sum,
          expense_category_name: item.expense_category_name,

        }), this);
      }
      return this.resultsData;
    },
    prepareTotals() {
      if (this.allTotals && this.allTotals.data) {
        this.allTotalsForPeriod = this.allTotals.data.map(item => ({
          name: item.name,
          sum: item.sum,
        }), this);
      }
      console.log(this.allTotalsForPeriod);
      return this.allTotalsForPeriod;
    },
    formTitle() {
      return this.editedIndex === -1 ? i18n.t('cashier.modal.create') : i18n.t('cashier.modal.edit');
    },
    formDateFormatted() {
      return this.formatDate(this.editedItem.datetime);
    },
  },
  mounted() {
    this.useNullableExpensesCategory = false;
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    editedItem: {
      handler(newVal) {
        this.$emit('filtering', newVal);
      },
      deep: true,
    },
  },
  methods: {
    getCurrentLocale() {
      return window.localStorage.language;
    },

    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      new ExpensesProxy()
        .destroy(this.editedItem.uuid)
        .catch(response => {
          console.error(response);
          alert(`Error: ${response.status}`);
          this.isRequestingNow = false;
        })
        .then(() => {
          this.$store.dispatch('page/updateCurrentPageContent');
        });

      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    save() {
      this.onActionExpenseDialog(this.editedItem);
      this.close();
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    changeDate(type, date) {
      console.log(type);
      if (date === null) {
        this.searchParams[type] = null;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.table-action
  &:hover
    fill: #0066ff
    transition: fill 0.5s
    cursor: pointer
</style>
